import produce from 'immer';
import { LoadingEnv } from '@/webapi/use-widget-catalog-api';
import { QBItemProp } from '@/components/query-builder/models';

export function enrichRecsStrategy(
  cleaned: LoadingEnv,
  props: QBItemProp[],
  ruleProps?: QBItemProp[],
): LoadingEnv {
  if (!cleaned?.recommendationOptions?.layeredRuling) {
    return cleaned;
  }

  return produce(cleaned, (draft) => {
    draft?.recommendationOptions?.layeredRuling?.forEach?.((rule, idx) => {
      rule?.ruleCond?.items?.forEach?.((item) => {
        if (item.qbProps) {
          item.qbProps = ruleProps.find(
            (q) => q.envKey === item.qbProps.envKey,
          );
        }
      });

      if (!rule?.isOpen && idx === 0) {
        rule.isOpen = true;
      }

      rule?.strategyCond?.forEach?.((cond) => {
        if (cond.qbProps) {
          cond.qbProps = props.find((q) => q.envKey === cond.qbProps.envKey);
        }
      });
    });
  });
}
